import React from 'react';

import Text from '@sats-group/ui-lib/react/text';

import { CampaignBanner as Props } from './campaign-banner.props';

const CampaignBanner: React.FC<Props> = ({ label, title }) => {
  return (
    <div className="campaign-banner">
      <div className="campaign-banner__label">
        <Text theme={Text.themes.headline} italic>
          {label}
        </Text>
      </div>
      <div className="campaign-banner__title">
        <Text>{title}</Text>
      </div>
    </div>
  );
};

export default CampaignBanner;
